import { Component, Input, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';
import { DeviceInfoService } from 'src/app/services/device-info.service';

@Component({
	selector: 'app-print-button',
	templateUrl: './print-button.component.html',
	styleUrls: ['./print-button.component.scss'],
})
export class PrintButtonComponent {
	@Input() customFunction?: () => void;
	@Input() hideText?: boolean;
	@Input() tableQuerySelector?: string;
	@Input() AllClients?: any[];
	@Input() agents$?: BehaviorSubject<any[]>;
	@Input() radioControl?: FormControl<string>;

	constructor(public device: DeviceInfoService) {}

	handleWhichFunctionToUse() {
		if (this.customFunction) {
			this.customFunction();
			return;
		}

		this.openPrintDialog();
	}

	openPrintDialog() {
		window.print();
	}
}
